// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:12:21

export default {
  "id": "physics-box-2",
  "slug": "physics-box-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/40334ddfb4e14ae49ffe344c6d380355-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/40334ddfb4e14ae49ffe344c6d380355/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Physics Box 2",
      "description": "Get ready for a fun and challenging physics game with 45 levels to complete. Easy to play but challenging to complete. Just tap or click on the screen to shoot an impulse out of the box that will make it move. Trickly levels will have you getting the box to buttons to open gates, avoiding sawtooth obstacles and making the box invincible to laser gates.",
      "instructions": "Just tap or click on the game to shoot an impulse in that direction to get the box flying.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "ball",
        "gravity",
        "physics"
      ]
    },
    "zh-CN": {
      "title": "物理盒子2",
      "description": "准备好一款充满乐趣和挑战的物理游戏，共有45个关卡等你完成。玩法简单，但完成难度高。只需轻触或点击屏幕，就能从箱子中射出一股脉冲，使其移动。在滑稽关卡中，你需要引导箱子触动按钮打开大门，避开锯齿形障碍物，并使箱子免受激光门的影响。",
      "instructions": "只需轻触或点击游戏，向该方向发射脉冲，让箱子飞起。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "球体",
        "重力",
        "物理"
      ]
    },
    "zh-TW": {
      "title": "物理盒子2",
      "description": "準備好享受一場有趣且挑戰性的物理遊戲，共有45個關卡等著您去完成。遊戲操作簡單，但想要完成則相當挑戰。只需在螢幕上輕觸或點擊，就能從盒子中射出衝擊波，讓盒子移動。挑戰關卡將讓您操作盒子去按按鈕開啟門戶，避開釘針狀障礙物，並讓盒子對於雷射門免疫。",
      "instructions": "只需輕觸或點擊遊戲即可在該方向發射衝擊波，使箱子飛行。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "球體",
        "重力",
        "物理學"
      ]
    },
    "zh-HK": {
      "title": "物理盒2",
      "description": "為您準備了一款充滿樂趣及挑戰的物理遊戲，共有45個關卡等待您完成。遊戲易於操作但難以通關。只需輕觸或點擊螢幕，即可從盒子中射出一股衝力，使其移動。在「滑溜關卡」中，您需要將盒子帶到按鈕上打開閘門，避開鋸齒障礙物，並讓盒子對雷射閘門免疫。",
      "instructions": "只需輕觸或點擊遊戲，向該方向發射衝擊波，讓箱子飛起。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "波爾",
        "重力",
        "物理學"
      ]
    },
    "ja": {
      "title": "物理ボックス2",
      "description": "45レベルの面白くて挑戦的な物理ゲームで遊びましょう。簡単に遊べますが、クリアするのは挑戦的です。画面をタップしたりクリックしたりして、箱から推進力を放出し、箱を動かしましょう。トリッキーなレベルでは、箱をボタンに導いて扉を開き、鋸歯状の障害物を避け、レーザーゲートに無敵の箱を作成します。",
      "instructions": "ゲームをタップしたりクリックしたりして、その方向にパルスを発射し、箱を飛ばしましょう。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "ボール",
        "重力",
        "物理"
      ]
    },
    "ko": {
      "title": "물리 박스 2",
      "description": "준비하세요. 45레벨을 완료해야 하는 재미있고 도전적인 물리학 게임입니다. 쉽게 플레이하지만 완료하기는 도전적입니다. 스크린을 탭하거나 클릭하여 상자에서 진동을 발사해 이동시킵니다. 트릭리 레벨에서는 상자를 버튼에 도착시켜 문을 열고, 사이저 장애물을 피하고 레이저 문에 대처할 수 있게 만들어줍니다.",
      "instructions": "게임을 탭하거나 클릭하여 해당 방향으로 일격을 가해 상자를 날려보내세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "공",
        "중력",
        "물리학"
      ]
    },
    "fr": {
      "title": "Boîte de Physique 2",
      "description": "Préparez-vous à un jeu de physique amusant et défiant avec 45 niveaux à terminer. Facile à jouer mais défiant à compléter. Tapez ou cliquez sur l'écran pour déclencher une impulsion hors de la boîte qui la fera bouger. Les niveaux malicieux vous amèneront à faire passer la boîte à des boutons pour ouvrir des portes, à éviter des obstacles en forme de dents de scie et à rendre la boîte invincible aux portes de laser.",
      "instructions": "Appuyez ou cliquez sur le jeu pour envoyer un impulse dans cette direction pour faire voler la boîte.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "balle",
        "gravité",
        "physique"
      ]
    }
  }
};
